// extracted by mini-css-extract-plugin
export default {"wrapper":"SortingBlock_wrapper__MkOHi","label":"SortingBlock_label__nKeP6","select":"SortingBlock_select__dlWnI","count":"SortingBlock_count__CnA1d"};